import './style.scss';
import { AlertProps, AlertType, AlertHeadingTag } from '../../Shared/Alert/models/alert.model';
import { SanitizerService } from '../../../services/sanitizer.service';
import DataUrlHelper from '../../../helpers/data-url.helper';
import checkGreen from '../../../../assets/icons/check-3-default-green-700.svg';
import exclamationCircle from '../../../../assets/icons/exclamation-circle-red-600.svg';
import { t } from '../../../services/texts.service';

function getIconSrc(type: AlertType): string {
  switch (type) {
    case AlertType.Success:
      return DataUrlHelper.encode(checkGreen);
    case AlertType.Error:
    case AlertType.Warning:
      return DataUrlHelper.encode(exclamationCircle);
    default:
      return '';
  }
}

function Alert({ show, heading, headingTag = 'div', content, type = AlertType.Error, closable, onClose, className }: AlertProps) {
  const HeadingTag: AlertHeadingTag = headingTag;
  const showCloseBtn = closable && !!onClose;
  const alertClass = ['alert', `alert-${type}`].filter(Boolean).join(' ');
  const contentClass = `d-flex align-items-center${content ? ' mb-2' : ''}${showCloseBtn ? ' pe-4' : ''}`;
  const isError = type === AlertType.Error;
  const alert = (
    <div className={alertClass} role={isError ? 'alert' : undefined}>
      {showCloseBtn && <button type="button" className="btn-close" aria-label={t.close} onClick={onClose}></button>}

      <div className={contentClass}>
        {/* Default alertType should not have an icon */}
        {type !== AlertType.Default && <img src={getIconSrc(type)} alt="" className="me-2" />}
        {heading && <HeadingTag className="fw-bold alert-heading h4 m-0">{heading}</HeadingTag>}
      </div>

      {content && <div className={`last-child-margin-bottom-none`} dangerouslySetInnerHTML={{ __html: SanitizerService.sanitizeHtml(content) }}></div>}
    </div>
  );

  if (isError) {
    return show && <div className={className ?? ''}>{alert}</div>;
  }

  return (
    <div className={show ? (className ?? '') : ''} role="status" aria-live="polite" aria-atomic="true">
      {show && alert}
    </div>
  );
}
export default Alert;
